import React, { useState, useEffect, useCallback } from 'react';
import {
  CardBody,
  Row,
  Col,
  Card,
  Container,
  CardHeader,
  Button,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Label,
  Input,
  Badge,
} from 'reactstrap';
import DataTable from 'react-data-table-component';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import metaMask from '../../assets/images/nft/newrecord.png';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import axios from 'axios';
import { api, web } from '../../config';
import { getAuthToken } from '../../auth/tokenvalidation';
import './HpsView.css';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import UserFormModal from './component/UserFormModal';

const ProcurementList = () => {
  const token = getAuthToken();
  const [data, setData] = useState({ items: [] });
  const [modal, setModal] = useState(false);
  const [errors, setErrors] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchText, setSearchText] = useState('');
  const [sortField, setSortField] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');
  const [isLoading, setIsLoading] = useState(false);
  const [debouncedSearchText, setDebouncedSearchText] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setFormData] = useState({
    titleProcurement: '',
    procurementType: '',
    description: '',
  });

  // Debounce search text
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchText(searchText);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchText]);

  const procurementtype = [
    {
      options: [
        { label: 'Select Procurement Type', value: '' },
        { label: 'Pelelangan Khusus', value: 'PelelanganKhusus' },
        { label: 'Pemilihan Langsung', value: 'PemilihanLangsung' },
        { label: 'Tunjuk Langsung', value: 'TunjukLangsung' },
      ],
    },
  ];

  const togglemodal = () => {
    setModal(!modal);
  };

  const columns = [
    {
      name: (
        <span className='form-label text-uppercase fw-semibold fs-13'>
          User Name
        </span>
      ),
      selector: row => row.userName,
      sortable: true,
      width: '15%',
      wrap: true,
      cell: row => (
        <div className='d-flex align-items-center'>
          <h6 className='mb-0 text-truncate'>{row.userName}</h6>
        </div>
      ),
    },
    {
      name: (
        <span className='form-label text-uppercase fw-semibold fs-13'>
          Email
        </span>
      ),
      selector: row => row.email,
      sortable: true,
      width: '15%',
      grow: 1,
      wrap: true,
      cell: row => (
        <div className='d-flex align-items-center'>
          <h6
            className='mb-0'
            style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}
            title={row.email}
          >
            {row.email}
          </h6>
        </div>
      ),
    },
    {
      name: (
        <span className='form-label text-uppercase fw-semibold fs-13'>
          Display Name
        </span>
      ),
      selector: row => row.procurementType,
      sortable: true,
      width: '10%',
      wrap: true,
      omit: window.innerWidth < 768,
      cell: row => (
        <div className='d-flex align-items-center'>
          <h6
            className='mb-0'
            style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}
            title={row.displayName}
          >
            {row.displayName}
          </h6>
        </div>
      ),
    },
    {
      name: (
        <span className='form-label text-uppercase fw-semibold fs-13'>
          Company/Job Title
        </span>
      ),
      selector: row => row.productType?.name,
      sortable: true,
      width: '20%',
      wrap: true,
      omit: window.innerWidth < 992,
      cell: row => (
        <div>
          <span
            className='fw-medium d-block'
            style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}
          >
            {row.companyName || '-'}
          </span>
          {row.jobTitle && (
            <p
              className='text-muted mb-0 small'
              style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}
            >
              {row.jobTitle}
            </p>
          )}
        </div>
      ),
    },

    {
      name: (
        <span className='form-label text-uppercase fw-semibold fs-13'>
          Type
        </span>
      ),
      width: '10%',
      sortable: false,
      center: false,
      cell: row => {
        const isMitra = row.roles?.some(role => role.toLowerCase() === 'dmut');
        return (
          <span
            className={`badge fs-12 ${isMitra ? 'bg-primary' : 'bg-secondary'}`}
          >
            {isMitra ? 'MITRA' : 'PERTAMINA'}
          </span>
        );
      },
    },

    {
      name: (
        <span className='form-label text-uppercase fw-semibold fs-13'>
          Role
        </span>
      ),
      width: '20%',
      sortable: false,
      center: false,
      cell: row => {
        return (
          <div className='d-flex flex-wrap gap-1'>
            {row.roles?.length > 0
              ? row.roles.map((role, idx) => (
                  <span key={idx} className='badge bg-info fs-12'>
                    {role}
                  </span>
                ))
              : '-'}
          </div>
        );
      },
    },
    {
      name: (
        <span className='form-label text-uppercase fw-semibold fs-13'>
          Action
        </span>
      ),
      width: '10%',
      center: true,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      cell: row => (
        <div className='d-flex gap-1 justify-content-end'>
          <Link
            to={`../apps-usermanagement/dtl/${row?.id || ''}`}
            className='btn btn-soft-info btn-sm btn-icon'
          >
            <i className='ri-eye-line align-bottom' title='View'></i>
          </Link>
          <Button
            className='btn btn-soft-info btn-sm btn-icon'
            onClick={() => handleEditClick(row)}
            title='Edit'
          >
            <i className='ri-pencil-line  align-bottom'></i>
          </Button>
          <Button
            className='btn btn-soft-danger btn-sm btn-icon'
            outline
            onClick={() => handleDelete(row.id)}
            title='Delete'
          >
            <i className='ri-delete-bin-6-line align-bottom'></i>
          </Button>
        </div>
      ),
    },
  ];

  document.title = 'List User Management ';

  const handleprocurementTypeChange = selectedOption => {
    setFormData({ ...formData, procurementType: selectedOption.value });
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateFields = () => {
    let tempErrors = {};
    if (!formData.titleProcurement) {
      tempErrors.titleProcurement = 'Please Enter Title';
    }
    if (!formData.procurementType) {
      tempErrors.procurementType = 'Please Select ';
    }

    if (!formData.description) {
      tempErrors.description = 'Please Enter Description';
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const closeModal = () => {
    setFormData({
      titleProcurement: '',
      procurementType: '',
    });
    setErrors({});
    setModal(!modal);
  };

  const handleSubmit = async e => {
    if (validateFields()) {
      e.preventDefault();
      try {
        setIsLoading(true);
        const response = await axios.post(
          `${api.API_URL}/procurement`,
          formData,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.success) {
          toast.success(`Data Has Been Saved `);
          window.location = `${web.WEB_URL}/apps-procurement/upd/${response.data.id}`;
        } else {
          toast.error('Failed to save data. Check server response..');
        }
      } catch (error) {
        toast.error(`Failed to save data.: ${error.message}`);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchData(
      currentPage,
      rowsPerPage,
      token,
      debouncedSearchText,
      sortField,
      sortDirection
    );
  }, [
    currentPage,
    rowsPerPage,
    token,
    debouncedSearchText,
    sortField,
    sortDirection,
  ]);

  const fetchData = async (
    currentPage,
    rowsPerPage,
    token,
    search = '',
    sort = '',
    direction = 'asc'
  ) => {
    setIsLoading(true);
    let url = `${api.API_URL}/appuser?PageNumber=${currentPage}&PageSize=${rowsPerPage}`;
    if (search && search.trim()) {
      url += `&search=${encodeURIComponent(search.trim())}`;
    }
    if (sort && sort !== '') {
      url += `&sortBy=${sort}&sortDirection=${direction}`;
    }

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        credentials: 'same-origin',
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      setData({
        items: result.data?.items || [],
      });
      setTotalRows(result.data?.totalItems || 0);
    } catch (error) {
      toast.error(`Error loading data: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditClick = user => {
    setSelectedUser(user);
    setShowEditModal(true);
  };

  const handleDelete = async id => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    });
    if (result.isConfirmed) {
      try {
        const res = await fetch(`${api.API_URL}/appuser/${id}`, {
          method: 'DELETE',
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
          fetchData(
            currentPage,
            rowsPerPage,
            token,
            debouncedSearchText,
            sortField,
            sortDirection
          );
          Swal.fire('Deleted!', 'User has been deleted.', 'success');
        } else {
          Swal.fire('Error', 'Failed to delete user', 'error');
        }
      } catch (e) {
        Swal.fire('Error', 'Network error', 'error');
      }
    }
  };

  const handleSort = (column, sortDirection) => {
    const field = column.selector
      ? column.selector.toString().split('.').pop()
      : '';
    setSortField(field);
    setSortDirection(sortDirection);
  };

  const handleSearch = e => {
    setSearchText(e.target.value);
    setCurrentPage(1); // Reset to first page when searching
  };

  const clearFilters = () => {
    setSearchText('');
    setSortField('');
    setSortDirection('asc');
    setCurrentPage(1);
  };

  const handlePageChange = useCallback(page => {
    setCurrentPage(page);
  }, []);

  const handlePerRowsChange = useCallback(newPerPage => {
    setRowsPerPage(newPerPage);
    setCurrentPage(1);
  }, []);

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <BreadCrumb title='View Data' pageTitle='User Management' />
          <Row>
            <Col lg={12}>
              <Card id='HazardList'>
                <CardHeader className='border-0'>
                  <div className='d-flex align-items-center justify-content-between'>
                    <h5 className='card-title mb-0 flex-grow-1'>
                      User Management
                    </h5>
                    <div className='flex-shrink-0'>
                      <div className='d-flex gap-2 flex-wrap'>
                        <button
                          type='button'
                          className='btn btn-primary btn-label right ms-auto nexttab btn-sm'
                          onClick={() => setShowAddModal(true)}
                        >
                          <i className='ri-play-list-add-line label-icon align-middle fs-16 ms-2'></i>{' '}
                          <span className='d-none d-sm-inline'>
                            Create New User
                          </span>
                          <span className='d-sm-none'>New</span>
                        </button>
                      </div>
                    </div>
                    {/* {searchText && (
                      <div className='d-flex align-items-center'>
                        <span className='badge bg-primary me-2'>
                          <i className='ri-search-line me-1'></i>
                          Search Active
                        </span>
                        <small className='text-muted'>
                          {totalRows} result(s) found
                        </small>
                      </div>
                    )} */}
                  </div>
                </CardHeader>

                <CardBody className='pt-0'>
                  {/* Search Controls */}
                  <Row className='mb-3 filter-row'>
                    <Col md={8} lg={6}>
                      <div className='search-box'>
                        <Input
                          type='text'
                          className='form-control'
                          placeholder='Search by user name or email...'
                          value={searchText}
                          onChange={handleSearch}
                        />
                        <i className='ri-search-line search-icon'></i>
                      </div>
                    </Col>
                    <Col md={4} lg={6}>
                      <div className='d-flex justify-content-end'>
                        {searchText && (
                          <button
                            type='button'
                            className='btn btn-outline-secondary'
                            onClick={clearFilters}
                          >
                            <i className='ri-refresh-line me-1'></i>
                            Clear Search
                          </button>
                        )}
                      </div>
                    </Col>
                  </Row>

                  <div className='table-responsive-container'>
                    <DataTable
                      columns={columns}
                      data={data.items}
                      pagination
                      paginationServer
                      paginationTotalRows={totalRows}
                      onChangePage={handlePageChange}
                      onChangeRowsPerPage={handlePerRowsChange}
                      onSort={handleSort}
                      sortServer
                      highlightOnHover
                      responsive
                      striped
                      persistTableHead
                      progressPending={isLoading}
                      progressComponent={
                        <div className='text-center py-4'>
                          <div
                            className='spinner-border text-primary'
                            role='status'
                          >
                            <span className='sr-only'>Loading...</span>
                          </div>
                          <p className='mt-2 text-muted'>Loading data...</p>
                        </div>
                      }
                      paginationRowsPerPageOptions={[10, 15, 25, 50]}
                      noDataComponent={
                        <div className='text-center py-4'>
                          <div className='mb-3'>
                            <i className='ri-search-line fs-2 text-muted'></i>
                          </div>
                          <h5 className='mt-2'>No data found</h5>
                          <p className='text-muted mb-0'>
                            {searchText
                              ? 'No results match your search criteria. Try adjusting your search terms.'
                              : 'No data available at the moment.'}
                          </p>
                        </div>
                      }
                      customStyles={{
                        table: {
                          style: {
                            tableLayout: 'auto',
                            width: '100%',
                          },
                        },
                        header: {
                          style: {
                            backgroundColor: '#f8f9fa',
                            color: '#495057',
                            fontWeight: 'bold',
                            borderBottom: '1px solid #dee2e6',
                          },
                        },
                        headCells: {
                          style: {
                            backgroundColor: '#f8f9fa',
                            fontWeight: '600',
                            fontSize: '13px',
                            color: '#495057',
                            paddingLeft: '12px',
                            paddingRight: '12px',
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                          },
                        },
                        rows: {
                          style: {
                            minHeight: '35px',
                            fontSize: '14px',
                            '&:hover': {
                              backgroundColor: '#f8f9fa',
                            },
                          },
                        },
                        cells: {
                          style: {
                            paddingLeft: '12px',
                            paddingRight: '12px',
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            overflow: 'visible',
                          },
                        },
                        pagination: {
                          style: {
                            borderTop: '1px solid #dee2e6',
                            marginTop: '10px',
                          },
                        },
                      }}
                    />
                    <ToastContainer closeButton={false} limit={1} />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        size='lg'
        isOpen={modal}
        role='dialog'
        autoFocus={true}
        centered
        id='addAddressModal'
        toggle={togglemodal}
        data-bs-backdrop='static'
      >
        <ModalHeader
          toggle={() => {
            setModal(!modal);
          }}
        ></ModalHeader>
        <ModalBody>
          <div className='d-flex mt-2'>
            <Col xxl={12}>
              <div>
                <Row>
                  <Row className='justify-content-center mb-1'>
                    <Col lg={12} className='text-center'>
                      <img
                        src={metaMask}
                        alt=''
                        height='65'
                        className='mb-3 pb-2'
                      />
                      <h5>Create New Planning & Procurement </h5>
                      <p className='text-muted pb-1'>
                        Start a new procurement request by filling in the
                        details below.
                      </p>
                    </Col>
                  </Row>
                  <Col lg={12}>
                    <div className='mb-2 bor border-top  border-top-dashed '></div>
                  </Col>
                  <Col sm={6}>
                    <div className='mb-2'>
                      <Label htmlFor='titleProcurement' className='form-label'>
                        Title Procurement
                        {errors.titleProcurement && (
                          <Badge color='warning' className='badge-label '>
                            <i className='mdi mdi-circle-medium'></i>{' '}
                            {errors.titleProcurement}{' '}
                          </Badge>
                        )}{' '}
                      </Label>
                      <Input
                        type='text'
                        className='form-control '
                        id='titleProcurement'
                        name='titleProcurement'
                        placeholder='Enter Title Procurement'
                        onChange={e => {
                          handleChange(e);
                          setErrors({
                            ...errors,
                            titleProcurement: '',
                          });
                        }}
                      />
                    </div>
                  </Col>
                  <Col sm={6}>
                    <div className='mb-2'>
                      <span
                        htmlFor='choices-publish-status-input'
                        className='form-label'
                      >
                        Procurement Type{' '}
                        {errors.procurementType && (
                          <Badge color='warning' className='badge-label '>
                            <i className='mdi mdi-circle-medium'></i>{' '}
                            {errors.procurementType}{' '}
                          </Badge>
                        )}{' '}
                      </span>

                      <Select
                        name='procurementType'
                        id='procurementType'
                        placeholder='-- Please Select --'
                        options={procurementtype}
                        onChange={e => {
                          handleprocurementTypeChange(e);
                          setErrors({
                            ...errors,
                            procurementType: '',
                          });
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12}>
                    <div>
                      <Label
                        htmlFor='exampleFormControlTextarea5'
                        className='form-label'
                      >
                        Description{' '}
                        {errors.description && (
                          <Badge color='warning' className='badge-label '>
                            <i className='mdi mdi-circle-medium'></i>{' '}
                            {errors.description}{' '}
                          </Badge>
                        )}{' '}
                      </Label>
                      <textarea
                        className='form-control'
                        id='description'
                        name='description'
                        onChange={e => {
                          handleChange(e);
                          setErrors({
                            ...errors,
                            description: '',
                          });
                        }}
                        rows='5'
                      ></textarea>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className='hstack gap-2 justify-content-end d-print-none mt-4'>
            <button
              color='primary'
              type='button'
              className='btn  btn-primary w-100'
              onClick={closeModal}
            >
              <i className='  ri-logout-box-line align-bottom me-1'></i>Close
            </button>
            <button
              type='submit'
              className='btn btn-primary btn-label right ms-auto nexttab'
              onClick={handleSubmit}
            >
              <i className='ri-arrow-right-line label-icon align-middle fs-16 ms-2'></i>{' '}
              Next
            </button>
          </div>
        </ModalFooter>
      </Modal>

      <UserFormModal
        isOpen={showAddModal}
        toggle={() => setShowAddModal(false)}
        userData={null}
        onSuccess={() => {
          fetchData(
            currentPage,
            rowsPerPage,
            token,
            debouncedSearchText,
            sortField,
            sortDirection
          );
        }}
      />

      <UserFormModal
        isOpen={showEditModal}
        toggle={() => setShowEditModal(false)}
        userData={selectedUser}
        onSuccess={() => {
          fetchData(
            currentPage,
            rowsPerPage,
            token,
            debouncedSearchText,
            sortField,
            sortDirection
          );
        }}
      />
    </React.Fragment>
  );
};

export default ProcurementList;
